var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 126,
    viewBox: "0 0 100 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6075 62.5569C66.8829 62.5569 80.8859 48.5531 80.8859 31.2785C80.8859 14.0047 66.8832 0 49.6075 0C32.3337 0 18.329 14.0047 18.329 31.2785C18.3424 48.5473 32.3386 62.5437 49.6075 62.5569ZM49.6075 5.3013C63.9548 5.3013 75.5846 16.9311 75.5846 31.2785C75.5846 45.6258 63.9548 57.2556 49.6075 57.2556C35.2619 57.2556 23.6303 45.6258 23.6303 31.2785C23.6543 16.942 35.2708 5.32445 49.6075 5.3013ZM49.6075 70.3766C36.0102 70.3766 23.3656 75.6514 13.983 85.2473C4.46602 94.9754 -0.75647 108.255 -0.75647 122.676C-0.752221 124.138 0.432643 125.322 1.8945 125.326H97.3209C98.7836 125.322 99.9667 124.138 99.971 122.676C99.971 108.282 94.7493 94.9754 85.2335 85.2739C75.8499 75.6779 63.2062 70.3764 49.6073 70.3764L49.6075 70.3766ZM4.599 120.025C5.18229 108.044 9.82064 97.0964 17.7466 88.9846C26.1228 80.4223 37.4417 75.7051 49.5818 75.7051C61.7218 75.7051 73.0407 80.4223 81.4161 88.9846C89.3686 97.0964 93.9812 108.044 94.5645 120.025H4.599Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.98a20f05ac89d46f81cc93c5d4c548c2.svg";
export { ForwardRef as ReactComponent };